import { render, staticRenderFns } from "./recentAlarmEvent.vue?vue&type=template&id=0b51dc76&scoped=true"
import script from "./recentAlarmEvent.vue?vue&type=script&lang=js"
export * from "./recentAlarmEvent.vue?vue&type=script&lang=js"
import style0 from "./recentAlarmEvent.vue?vue&type=style&index=0&id=0b51dc76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b51dc76",
  null
  
)

export default component.exports